import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    userData: {
        id: null,
        customerName: "",
        customerPhone: "",
        customerPhone2: "",
        email: "",
        address: "",
        clientType: "individual",
        // Individual fields
        passportGivenPlace: "",
        passportGivenDate: "",
        series: "",
        pnfl: "",
        birthDate: "",
        // Legal fields
        director: "",
        bank: "",
        bank_account: "",
        mfo_code: "",
        oked_code: "",
        inn: "",
        favorites: []
    }
}

export const userDataSlice = createSlice({
    name: 'userData',
    initialState,
    reducers: {
        attachUser: (state, {payload}) => {

            state.userData = payload
        },
        clearAttach: (state) => {
            state.userData = {
                id: null,
                customerName: "",
                customerPhone: "",
                customerPhone2: "",
                email: "",
                address: "",
                clientType: "individual",
                passportGivenPlace: "",
                passportGivenDate: "",
                series: "",
                pnfl: "",
                birthDate: "",
                director: "",
                bank: "",
                bank_account: "",
                mfo_code: "",
                oked_code: "",
                inn: "",
                favorites: []
            }
        },
        updateFavorites: (state, {payload}) => {
            state.userData.favorites = payload
        },
        updateClientData: (state, {payload}) => {
            state.userData = {...state.userData, ...payload}
        },

    },
})

// Action creators are generated for each case reducer function
export const {attachUser, clearAttach, updateFavorites, updateClientData} = userDataSlice.actions

export default userDataSlice.reducer